import { IAdminProfile, IAdminProfileResponse } from '@/models/admins.model';

export const normalizeAdminProfileData = (data: IAdminProfileResponse): IAdminProfile => {
  return {
    firstName: data.data.first_name,
    lastName: data.data.last_name,
    email: data.data.email,
    id: data.data.id,
    role: data.data.role,
    regionId: data.data.region_id ?? null,
    regionName: data.data.region?.name ?? '',
    permissions: data.data.permissions ?? [],
  };
};
